import type { MapRef } from 'react-map-gl/mapbox';

/**
 * Convert a distance in meters to pixels based on the ratio of the map's bounds to its container size using a straight diagonal line across the map.
 * Note that do distortion from map projection this will not be completely accurate but should be close enough for scaling purposes.
 * @param map MapRef
 * @param distance distance to convert in meters
 * @returns distance in pixels
 */
const getDistanceInPixels = (map: MapRef, distance: number) => {
  if (!map) {
    return;
  }

  const container = map.getContainer().getBoundingClientRect();
  const { width, height } = container;

  // Assuming using a diagonal will help mitiage inaccuracies caused by the map's projection
  const diagonalPixels = Math.sqrt(width ** 2 + height ** 2);

  const bounds = map.getBounds();

  if (!bounds) {
    return;
  }

  const diagonalMeters = bounds.getNorthEast().distanceTo(bounds.getSouthWest());

  return (distance / diagonalMeters) * diagonalPixels;
};

export default getDistanceInPixels;
